<template>
  <div class="examcover-container">
    <div class="examcover-table">
      <div class="examcover-title">{{examName}}</div>
      <div class="examcover-time">有效日期：{{examTime}}</div>
      <div class="examcover-explain">
        <ul>
          <li class="examcover-table-content" v-show="isMook == 1">
            <div class="examcover-table-content-number">{{questionCount}}</div>
            <span class="examcover-table-content-time">题目</span>
          </li>
          <li class="examcover-table-content" v-show="isMook != 1">
            <div class="examcover-table-content-number">{{examDuration}}:00</div>
            <span class="examcover-table-content-time">考试时长</span>
          </li>
          <li class="examcover-table-content">
            <div class="examcover-table-content-number">{{totalScore}}</div>
            <span class="examcover-table-content-time">试卷分数</span>
          </li>
          <li class="examcover-table-content">
            <div class="examcover-table-content-number">{{passScore}}</div>
            <span class="examcover-table-content-time">及格分数</span>
          </li>
          <li class="examcover-table-content" v-show="isMook != 1">
            <div class="examcover-table-content-number">{{times}}</div>
            <span class="examcover-table-content-time">剩余次数</span>
          </li>
          <li class="examcover-table-content" v-show="isMook != 1">
            <div class="examcover-table-content-number">{{score}}</div>
            <span class="examcover-table-content-time">获得学分</span>
          </li>
          <li class="examcover-table-content" v-show="isMook != 1">
            <div class="examcover-table-content-number">{{certificate}}</div>
            <span class="examcover-table-content-time">所获证书</span>
          </li>
        </ul>
      </div>
      <div class="examcover-text">
        <div class="examcover-smalltitle">考试说明</div>
        <div class="examcover-smalltext">{{info}}</div>
      </div>
      <div class="examcover-btn">
        <a @click="toExam" href="javascript:;">开始考试</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {getUrlKey} from '../../untils/common.js'
  import {ApiGetMockExamInfo, ApiGetExamInfo} from '../../net/exam/index.js'
  export default {
    data: function () {
      return {
        examId: 0,
        taskId: 0,
        isMook: 1, // 是否为模拟考试,1是
        examName: '', //试卷名
        examTime: '', //考试时间
        totalScore: 100, //总分
        passScore: 60, //及格分数
        certificate: 0, //证书数量
        questionCount: 0, //试题个数
        info: '', //试题描述
        times: 0, //剩余次数
        score: 0, // 通过本次考试获得的学分
        examDuration: 0, //考试时长
        examStatus: 1, //试卷状态   1未开始（考试时间还没有到）    2进行中      3已结束
      }
    },
    methods:{
      getMockExamInfo: function () {
        const prames = {examId: this.examId}
        ApiGetMockExamInfo(prames).then(res=>{
          if (res.code == 200) {
            this.examName = res.value.examName
            this.examTime = res.value.examTime
            this.totalScore = res.value.totalScore
            this.passScore = res.value.passScore
            this.certificate = res.value.certificate
            this.questionCount = res.value.questionCount
            this.info = res.value.info
          }
        })
      },
      getExamInfo: function () {
        const prames = {examId: this.examId, taskId: this.taskId}
        ApiGetExamInfo(prames).then(res=>{
          if (res.code == 200) {
            this.examName = res.value.examName
            this.examTime = res.value.examTime
            this.totalScore = res.value.totalScore
            this.passScore = res.value.passScore
            this.certificate = res.value.certificate
            this.questionCount = res.value.questionCount
            this.info = res.value.info
            this.score = res.value.score
            this.examDuration = res.value.examDuration
            this.examStatus = res.value.examStatus
            this.times = res.value.retakeCount
          }
        })

      },
      toExam: function () {
        if (this.examId == 0 ) {
          this.$message.warning('试卷获取失败')
          return
        }
        if (this.isMook !=1) {
          if( this.taskId == 0) {
            this.$message.warning('试卷获取失败')
            return
          }
          if (this.examStatus == 1) {
            this.$message.warning('该考试未开始')
            return
          }
          if (this.examStatus == 3) {
            this.$message.warning('该考试已结束')
            return
          }
          if (this.times <= 0) {
            this.$message.warning('重考次数已用完')
            return
          }
        }
        this.$router.push({
          path: '/Exam',
          query: {eid: this.examId}
        })
      }
    },
    mounted: function () {
      this.examId = getUrlKey('eid',window.location.href) || 0
      this.isMook = getUrlKey('isMook',window.location.href) || 0
      this.taskId = getUrlKey('taskId',window.location.href) || 0
      if (this.isMook == 1) { // 模拟考试
        this.getMockExamInfo()
      } else {
        this.getExamInfo()
      }

    }
  }
</script>

<style scoped>
.examcover-container{
  width: 1140px;
  margin:0 auto;
  background: #fff;
  border-radius: 6px;
  margin-top: 24px;
  min-height: 600px;
  overflow: hidden;
}
.examcover-table{
  width: 440px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
  border-radius: 6px;
  border:10px solid #f5f5f5;
  padding-top: 50px;
  padding-bottom: 50px;
}
.examcover-title{
  width: 90%;
  margin:0 auto;
  font-size: 24px;
  color: #252525;
  text-align: center;
}
.examcover-time{
  width: 90%;
  margin:0 auto;
  color: #454545;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}
.examcover-explain{
  width: 330px;
  margin:0 auto;
  padding:5px 10px 20px 10px;
  background:#f5f5f5;
  border-radius: 6px;
  margin-top: 30px;
}
.examcover-explain ul {
  margin:0;
  padding:0;
  overflow: hidden;
}
.examcover-explain ul li{
  list-style-type: none;
  float: left;
  margin-top: 15px;
}
.examcover-table-content{
  width: 110px;
  text-align: center;
}
.examcover-table-content-number{
  font-size: 16px;
  color: #252525;
  line-height: 1.5;
}
.examcover-table-content-time{
  font-size: 14px;
  color: #999;
  margin-top: 5px;
  line-height: 1.5;
}
.examcover-text{
  width: 340px;
  margin: 0 auto;
  margin-top: 30px;
}
.examcover-smalltitle{
  font-size: 16px;
  color: #252525;
}
.examcover-smalltext{
  margin-top: 10px;
  font-size: 14px;
  color: #7f7f7f;
}
.examcover-btn{
  width: 340px;
  margin:0 auto;
}
.examcover-btn {
  color: #fff;
  width: 340px;
  height: 48px;
  text-align: center;
  border-radius: 6px;
  line-height: 48px;
  color: #fff;
  font-size: 16px;
  cursor:pointer;
  margin-top: 50px;
}
.examcover-btn a{
  width: 340px;
  height: 48px;
  text-decoration: none;
  color: #fff;
  background-color: #0AAC50;
  float: left;
  border-radius: 6px;
}
.examcover-btn :hover{
  background:#009640;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamDetail/ExamDetail.vue